import React, { useState } from 'react'
import { Form, Button, InputGroup } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { FcGoogle } from "react-icons/fc";
import { FaFacebookF } from "react-icons/fa";
import { useForm } from "react-hook-form";
import { VALIDATIONS, VALIDATIONS_TEXT } from '../../constants/app-constants';
import { success, error } from "../../constants/msg";
import { ToastContainer } from "react-toastify";
import { base_url } from "../../constants/baseUrl";
import axios from "axios"

const SignupForm = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const { register, handleSubmit, formState: { errors } } = useForm({
        mode: "onChange"
    });

    // const onSubmit = (data) => {
    //     const data1 = {
    //         "name": ".",
    //         "email": data.email,
    //         "password": data.password,
    //         "password_confirmation": data.password,
    //         "device_type": "web",
    //         "device_token": "aaaa",
    //         "role_id": 2
    //     }
    //     const response = axios.post(base_url + "/register", data1)
    //     .then((response) => {
    //         success("Signup Successfull")
    //         setTimeout(() => {
    //             navigate("/choose-plan")
    //         }, 1500)
    //         console.log(response.data.data.access_token)
    //         localStorage.setItem('access_token',response.data.data.access_token)
    //       })
    //     .catch(function (error) {
    //         if (error.response) {
    //             showError(error.response.data.message)
    //             console.log(error.response.status);
    //         }
    //     });

    // }

    const onSubmit = (data) => {
        success("Signup Successfull")
        setTimeout(() => {
            navigate("/choose-plan")
        }, 1500)
    }

    function showError(text) {
        error(text);
    }

    return (
        <section className='signup-section mt-3 mt-md-5'>
            <ToastContainer />
            <div className='d-block d-md-none text-center mb-4'>
                <h1 className='welcome-text'>WELCOME TO RODEO</h1>
            </div>
            <span className='d-block text-center mb-5'>Let's create your account <br /> Enter your details to setup your account.</span>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <InputGroup className='mt-3' controlId="email">
                    <Form.Control
                        name="email"
                        type="email"
                        placeholder="Email *"
                        {...register("email",
                            {
                                maxLength: {
                                    value: VALIDATIONS.EMAIL,
                                    message: VALIDATIONS_TEXT.EMAIL_MAX
                                },
                                required: {
                                    value: true,
                                    message: VALIDATIONS_TEXT.EMAIL_REQUIRED
                                },
                                pattern: {
                                    value: /\S+@\S+\.\S+/,
                                    message: VALIDATIONS_TEXT.EMAIL_FORMAT
                                }
                            })
                        }
                    />
                </InputGroup>
                {errors.email && <small className='text-red'>{errors.email.message}</small>}

                <InputGroup className='mt-3' controlId="Password">
                    <Form.Control
                        name="password"
                        className="password-input"
                        placeholder="Password *"
                        type={!showPassword ? "password" : "text"}
                        {...register("password",
                            {
                                minLength: {
                                    value: VALIDATIONS.PASSWORD_MIN,
                                    message: VALIDATIONS_TEXT.PASSWORD_MIN
                                },
                                maxLength: {
                                    value: VALIDATIONS.PASSWORD_MAX,
                                    message: VALIDATIONS_TEXT.PASSWORD_MAX
                                },
                                required: {
                                    value: true,
                                    message: VALIDATIONS_TEXT.PASSWORD_REQUIRED
                                },
                            })
                        }

                    />
                    <InputGroup.Text>
                        {
                            !showPassword ?
                                <AiOutlineEye className="eye-icon" onClick={() => setShowPassword(!showPassword)} /> :
                                <AiOutlineEyeInvisible className="eye-icon" onClick={() => setShowPassword(!showPassword)} />
                        }
                    </InputGroup.Text>
                </InputGroup>
                {errors.password && <small className='text-red'>{errors.password.message}</small>}


                <div className='text-center'>
                    <Button type="submit" className="w-100 mt-5">SIGN UP</Button>
                </div>
            </Form>

            <div className='text-center mt-5'>
                <span>or continue with</span>
                <div className='d-flex align-items-center mt-4'>
                    <Button className='d-flex align-items-center justify-content-center btn-google w-100 me-3'><FcGoogle className='me-2' />Sign in</Button>
                    <Button className='d-flex align-items-center justify-content-center btn-facebook w-100'><FaFacebookF className='me-2' />Sign in</Button>
                </div>
            </div>
        </section>
    )
}

export default SignupForm